import * as React from "react";
import "./uikit/uikit.css";
import { useLocation, useOutlet } from "react-router";
import { AppRoot } from "./uikit";
import { AnimatePresence } from "motion/react";
import getMiniappInitData from "./telegramMiniapp";
import trackAdOpen from "./utils/adUtm";

function App() {
  let { pathname } = useLocation();
  let element = useOutlet();

  React.useEffect(() => {
    trackAdOpen();
  }, []);

  try {
    const initDataRaw = getMiniappInitData();
    if (
      Object.keys(initDataRaw).length == 0 &&
      process.env.REACT_APP_TELEGRAM
    ) {
      return <></>;
    }
  } catch {}

  // const theme = localStorage.getItem("theme") ?? "light";
  const theme = "dark";
  const backgroundClass =
    pathname === "/login" ? "login-background" : "other-background";

  return (
    <AppRoot
      platform="base"
      appearance={theme}
      // className={backgroundClass + " " + (theme === "dark" ? "dark" : "")}
      className={backgroundClass + " dark"}
      id="app"
    >
      <AnimatePresence mode="wait">
        {element && React.cloneElement(element, { key: pathname })}
      </AnimatePresence>
    </AppRoot>
  );
}

export default App;
